import React from "react";
import createEngine, {
  DiagramModel,
  DefaultNodeModel,
  DefaultPortModel,
  DefaultLinkModel,
  NodeModel,
  DagreEngine,
  DiagramEngine,
  PathFindingLinkFactory
} from "@projectstorm/react-diagrams";
import { CanvasWidget } from "@projectstorm/react-canvas-core";

// import { EmailNodeFactory, EmailNodeModel } from './emailNode';
// import { JSCustomNodeFactory } from "./custom-node-js/JSCustomNodeFactory";
// import { JSCustomNodeModel } from "./custom-node-js/JSCustomNodeModel";

//import "./diagram.scss";

const createNode = name => {
  return new DefaultNodeModel(name, "rgb(0,192,255)");
};

let count = 0;

const connectNodes = (nodeFrom, nodeTo, engine) => {
  //just to get id-like structure
  count++;
  const portOut = nodeFrom.addPort(
    new DefaultPortModel(true, `${nodeFrom.name}-out-${count}`, "Out")
  );
  const portTo = nodeTo.addPort(
    new DefaultPortModel(false, `${nodeFrom.name}-to-${count}`, "IN")
  );
  // return portOut.link(portTo);

  // ################# UNCOMMENT THIS LINE FOR PATH FINDING #############################
  return portOut.link(
    portTo,
    engine.getLinkFactories().getFactory(PathFindingLinkFactory.NAME)
  );
  // #####################################################################################
};

export class AutoDistribute extends React.Component {
  constructor(props) {
    super(props);
    this.engine = new DagreEngine({
      graph: {
        rankdir: "LR",
        ranker: "tight-tree",
        marginx: 25,
        marginy: 25
      },
      includeLinks: false
    });
  }

  autoDistribute = () => {
    this.engine.redistribute(this.props.model);

    // only happens if pathfing is enabled (check line 25)
    this.reroute();
    this.props.engine.repaintCanvas();
    //SCARY LINE, THIS REFORCES THE VIEW TO RE_RENDER THE VIEW BASED ON MODEL CHANGING
    //PLEASE DONT TRY THIS AT HOME
    this.setState({});
  };

  componentDidUpdate = (prevProps, prevState) => {
    console.log("COMPONENT DID UPDATE");
    console.log(this.props.model);
    console.log(prevProps.model);
    if (this.props.model !== prevProps.model) {
      setTimeout(() => {
        this.autoDistribute();
        //this.setState({ redistributed: false });
      }, 500);
    }
  };

  componentDidMount() {
    setTimeout(() => {
      this.autoDistribute();
    }, 500);
  }

  reroute() {
    this.props.engine
      .getLinkFactories()
      .getFactory(PathFindingLinkFactory.NAME)
      .calculateRoutingMatrix();
  }

  render() {
    return (
      <CanvasWidget
        className="srd-demo-canvas"
        style={{ height: "100%", width: "100%" }}
        engine={this.props.engine}
        lock
      />
    );
  }
}

// class Diagram extends React.Component {
//   setup = () => {
//     // create an instance of the engine
//     const engine = createEngine();

//     // register the engine
//     //  engine.getNodeFactories().registerFactory(new JSCustomNodeFactory());

//     // create a diagram model
//     const model = new DiagramModel();

//     //####################################################
//     // now create two nodes of each type, and connect them

//     const node1 = new DefaultNodeModel({ color: "rgb(192,255,0)" });
//     node1.setPosition(50, 50);
//     let port1 = node1.addOutPort("Out");

//     const node2 = new DefaultNodeModel({ color: "rgb(0,192,255)" });
//     node2.setPosition(200, 50);
//     let port2 = node2.addInPort("In");

//     let link = port2.link(port1);

//     model.addAll(node1, node2, link);

//     //####################################################

//     // install the model into the engine
//     engine.setModel(model);

//     return [engine, model];
//   };

//   render() {
//     const [engine, model] = this.setup();

//     return (
//       <div
//         style={{
//           height: "100vh",
//           width: "75vw",
//           backgroundColor: "transparent"
//         }}
//       >
//         <AutoDistribute model={model} engine={engine} />
//       </div>
//     );
//   }
// }



// WEBPACK FOOTER //
// ./src/components/Flows/UI/Diagram.js